export default __webpack_public_path__ + "static/media/pin2.aa75ff72.svg";